const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getWeeklyAvgData = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_WEEKLY_AVG_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_WEEKLY_AVG_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getWeeklyAvgData;